export const OTP_WAIT_TIME = 30;

export const ACKO_LOGO_URL =
  "https://acko-brand.ackoassets.com/brand/vector-svg/gradient/gradient-horizontal.svg";

export const REQUEST_PAYLOAD = {
  fresh_car: {
    data: {
      is_new: false,
      origin: "acko",
      product: "car"
    },
    journey: "fresh_car"
  },
  renewal_car: {
    data: {
      is_new: false,
      origin: "acko_renewal",
      product: "car"
    },
    journey: "renewal_car"
  },
  renewal_bike: {
    data: {
      is_new: false,
      origin: "acko_renewal",
      product: "bike"
    },
    journey: "renewal_bike"
  },
  new_car: {
    data: {
      is_new: true,
      origin: "acko_new_car",
      product: "car"
    },
    journey: "new_car"
  },
  dashcam: {
    data: {
      is_new: false,
      origin: "acko",
      product: "car"
    },
    journey: "dashcam"
  }
};


export const PRODUCT_STATE = {
  chatbot_callback: "Callback Requested"

};

export const PLAN_IDS = {
  NON_NETWORK_GARAGE: [
    "car_acko_garage_comprehensive_deductible",
    "car_acko_garage_zero_dep_deductible"
  ],
  CLAIM_DESC: [
    "zero_dep_deductible",
    "zero_dep_deductible_od"
  ]
};

export const OWNERSHIP_TRANSFER_OPTIONS_NODE = "ownership_transfer_options_node";

// Nodes that don't require proposal_ekey
export const NODES_WITHOUT_PROPOSAL_EKEY = [
  "landing_page_node",
  "garage_details_node",
  "make_selection_node",
  OWNERSHIP_TRANSFER_OPTIONS_NODE
];

export const ACKO_GARAGE_BADGES = {
  ackoCertified: "ackoCertified",
  ackoOwned: "ackoOwned"
};

export enum FuelType {
  INTERNAL_LPG_CNG = "internal_lpg_cng",
  PETROL = "petrol",
  DIESEL = "diesel",
  ELECTRIC = "electric"
}

export const FUEL_TYPE_DISPLAY_MAP: Record<string, string> = {
  [FuelType.INTERNAL_LPG_CNG]: "CNG",
  [FuelType.PETROL]: "Petrol",
  [FuelType.DIESEL]: "Diesel",
  [FuelType.ELECTRIC]: "Electric"
};

export const FUEL_TYPES_TO_CAPITALIZE = [
  FuelType.PETROL,
  FuelType.DIESEL,
  FuelType.ELECTRIC
];